import createReducer from "../lib";
import { ProductTypes } from "../actions/_types";

const initialState = {
  dataTable: [],
  filters: {},
};

export const productReducer = createReducer(initialState, {
  [ProductTypes.PRODUCT_REQUEST](state, action) {
    return {
      ...state,
      ...action,
    };
  },
  [ProductTypes.INITIAL](state, action) {
    return {
      ...initialState,
    };
  },
});
